import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-19179985"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "btn__text" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 0,
  class: "btn__icon"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass(['btn', $props.bg, $props.size])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (!$props.loading)
        ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString($props.text), 1))
        : (_openBlock(), _createBlock(_component_Spinner, {
            key: 1,
            theme: "white"
          }))
    ]),
    ($props.icon)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createVNode(_component_Icon, {
            name: $props.icon,
            class: "btn-icon"
          }, null, 8, ["name"])
        ]))
      : _createCommentVNode("", true)
  ], 2))
}